module.exports = __webpack_public_path__ + "images/emoji/birthday.fa336188841acf6ef964.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/birthday.png
// module id = B5u7
// module chunks = 13